import { EPeriod } from "@domains/features/Markets/Options/entites/drivingMarket";
import { SET_PARAMS, DRIVING_MKT_CLEAR_MSG, DRIVING_MKT_SET_MSG, } from "../../interface/drivingMarket/iOptionDrivingMarketParams";
export const initCommonState = {
    limit: true,
    period: EPeriod.ONE_DAY,
    callMessage: {
        msg: null,
        show: false,
        icon: null,
    },
    putMessage: {
        msg: null,
        show: false,
        icon: null,
    },
};
const drivingMarketParamsReducer = (state = initCommonState, action) => {
    switch (action.type) {
        case SET_PARAMS:
            return Object.assign(Object.assign({}, state), action.payload);
        case DRIVING_MKT_SET_MSG:
            return Object.assign(Object.assign({}, state), { [action.callPutType]: action.callPutMsg });
        case DRIVING_MKT_CLEAR_MSG:
            return Object.assign(Object.assign({}, state), { [action.callPutType]: initCommonState[action.callPutType] });
        default:
            return Object.assign({}, state);
    }
};
export default drivingMarketParamsReducer;
